import React from 'react';

/** Empty-state illustration for itineraries. */
export function ItineraryArt() {
  return (
    <svg className="it-art" viewBox="0 0 420 230" aria-hidden="true">
      <rect className="it-art__sky" width="420" height="230" rx="28" />
      <circle className="it-art__sun" cx="346" cy="42" r="16" />
      <ellipse className="it-art__cloud" cx="64" cy="48" rx="18" ry="10" />
      <ellipse className="it-art__cloud" cx="84" cy="42" rx="14" ry="9" />
      <path className="it-art__hill" d="M0 150c48-28 92 10 140-12 40-18 74 16 124-6 34-14 70 8 156-18v116H0z" />
      <path className="it-art__hill it-art__hill--front" d="M0 186c70-18 110 14 176-2 50-12 86 16 244-10v56H0z" />
      <rect className="it-art__map" x="78" y="58" width="188" height="124" rx="18" />
      <path className="it-art__road" d="M92 146h160M96 108h148M118 72v96M188 72v96" />
      <ellipse className="it-art__park" cx="214" cy="132" rx="22" ry="14" />
      <path className="it-art__route" d="M108 156c26-18 42-6 64-24 16-14 36-8 58-28" />
      <circle className="it-art__start" cx="108" cy="156" r="7" />
      <circle className="it-art__end" cx="230" cy="104" r="7" />
      <path className="it-art__pin" d="M292 78c-16 22-28 36-28 52a28 28 0 0 0 56 0c0-16-12-30-28-52z" />
      <circle className="it-art__pin-core" cx="292" cy="128" r="8" />
    </svg>
  );
}

export default ItineraryArt;
